import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HenterPantComponent } from "./henter-pant.component";
import { ProfileComponent } from "./profile/profile.component";

const routes: Routes = [
  { path: '', component: HenterPantComponent, data: { titleKey: 'TITLE.HENTERPANT' } },
  { path: 'profile', component: ProfileComponent, data: { titleKey: 'TITLE.PROFILE' } },
  {
    path: 'compliance-suite',
    loadChildren: () => import('../../pages/compliance-suite/compliance-suite.module').then(m => m.ComplianceSuiteModule)
  },
  { path: 'how-henter-pant-works', redirectTo: 'slik-fungerer-det', pathMatch: 'full' },
  {
    path: 'slik-fungerer-det',
    loadChildren: () => import('../../pages/how-henter-pant-works/how-henter-pant-works.module').then(m => m.HowHenterPantWorksModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('../../pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('../../pages/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
  {
    path: 'hjelp',
    loadChildren: () => import('../../pages/legal-faq/legal-faq.module').then(m => m.LegalFaqModule)
  },
  { path: 'help', redirectTo: 'hjelp', pathMatch: 'full' },
  { path: 'faq', redirectTo: 'hjelp', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HenterPantRoutingModule { }
